<table mat-table matSort class="ob-table ob-table-plain no-link-decoration" [dataSource]="dataSource" aria-label="table">
	<ng-container [matColumnDef]="COLUMN_SELECT">
		<th mat-header-cell *matHeaderCellDef>
			<mat-checkbox
				id="edit-annotation-check-all"
				(change)="$event ? onMasterToggle() : null"
				[checked]="hasSelectedRows() && isAllSelected()"
				[indeterminate]="hasSelectedRows() && !isAllSelected()"
				matTooltip="{{ 'i18n.tooltip.checkbox_all' | translate }}"
			>
			</mat-checkbox>
		</th>
		<td mat-cell *matCellDef="let row">
			<mat-checkbox
				(click)="$event.stopPropagation()"
				(change)="$event ? onToggleSelection(row) : null"
				[checked]="isRowSelected(row)"
				matTooltip="{{ 'i18n.tooltip.checkbox_single' | translate }}"
			>
			</mat-checkbox>
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_ACTIONS">
		<th mat-header-cell *matHeaderCellDef>
			<div class="action-wrapper">
				<div class="action-button">
					<button
						id="edit-annotation-delete-rows-button"
						obButton="secondary"
						mat-icon-button
						matTooltip="{{ 'i18n.tooltip.delete_selected' | translate }}"
						(click)="onRemoveSelectedRows()"
						[disabled]="hasSelectedRows() === false"
					>
						<mat-icon svgIcon="delete" class="ob-icon"></mat-icon>
					</button>
				</div>
				<div class="action-button">
					<button
						id="edit-annotation-add-row-button"
						obButton="secondary"
						mat-icon-button
						(click)="onAddRow()"
						[disabled]="!canAdd()"
						matTooltip="{{ 'i18n.tooltip.addrow' | translate }}"
					>
						<mat-icon svgIcon="plus" class="ob-icon"></mat-icon>
					</button>
				</div>
			</div>
		</th>
		<td mat-cell *matCellDef="let row; let i = index">
			<div class="action-wrapper">
				<div class="action-button">
					<button
						id="edit-annotation-edit-row-button-{{ i }}"
						obButton="secondary"
						mat-icon-button
						[disabled]="hasSelectedRows()"
						(click)="onEditRow(row)"
						matTooltip="{{ 'i18n.tooltip.edit' | translate }}"
					>
						<mat-icon svgIcon="pencil" class="ob-icon"></mat-icon>
					</button>
				</div>
				<div class="action-button">
					<button
						id="edit-annotation-delete-row-button-{{ i }}"
						obButton="secondary"
						mat-icon-button
						[disabled]="hasSelectedRows()"
						(click)="onRemoveRow(i)"
						matTooltip="{{ 'i18n.button.remove.tooltip' | translate }}"
					>
						<mat-icon svgIcon="delete" class="ob-icon"></mat-icon>
					</button>
				</div>
			</div>
		</td>
	</ng-container>

	<ng-container [matColumnDef]="COLUMN_TYPE">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.type" | translate }}</th>
		<td mat-cell *matCellDef="let element">
			<div class="cell">
				{{ element?.type }}
			</div>
		</td>
	</ng-container>
	<ng-container [matColumnDef]="COLUMN_TITLE">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.title" | translate }}</th>
		<td class="cell" mat-cell *matCellDef="let element">
			{{ element?.title }}
		</td>
	</ng-container>
	<ng-container [matColumnDef]="COLUMN_TEXT">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.text" | translate }}</th>
		<td mat-cell *matCellDef="let element">
			<app-multiline-text [text]="(element.text | fallback: currentLanguage) ?? '-'"></app-multiline-text>
		</td>
	</ng-container>
	<ng-container [matColumnDef]="COLUMN_URI">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.uri" | translate }}</th>
		<td mat-cell *matCellDef="let element">
			{{ element?.uri }}
		</td>
	</ng-container>
	<ng-container [matColumnDef]="COLUMN_IDENTIFIER">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.identifier" | translate }}</th>
		<td class="cell" mat-cell *matCellDef="let element">
			{{ element?.identifier }}
		</td>
	</ng-container>
	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<div class="table-info-box">
	<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
</div>
